export default function SecuritySection() {
  return (
    <section className="relative w-full bg-secondary-50 py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        <span className="text-xs md:text-sm text-accent-600 font-medium tracking-wide">
          Bezpieczeństwo i prywatność
        </span>

        <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-medium text-foreground-950 leading-tight mt-4 mb-8 md:mb-12 max-w-2xl">
          Twoje dane{" "}
          <span className="inline-flex items-center align-middle mx-1">
            <img
              src="https://readdy.ai/api/search-image?query=Soft%20abstract%20warm%20golden%20amber%20gradient%20oval%20shape%20on%20transparent%20background%2C%20minimalist%20decorative%20element%2C%20smooth%20elegant%20edges%2C%20atmospheric%20subtle%20warm%20glow%2C%20no%20text%20no%20logos%2C%20clean%20simple%20design&width=100&height=60&seq=security-oval-v2&orientation=landscape"
              alt=""
              className="h-[0.9em] w-auto rounded-full"
            />
          </span>{" "}
          są z nami{" "}
          <span className="inline-flex items-center align-middle mx-1">
            <img
              src="https://readdy.ai/api/search-image?query=Soft%20abstract%20sage%20green%20mint%20gradient%20oval%20shape%20on%20transparent%20background%2C%20minimalist%20decorative%20element%2C%20smooth%20elegant%20edges%2C%20atmospheric%20subtle%20cool%20glow%2C%20no%20text%20no%20logos%2C%20clean%20simple%20design&width=100&height=60&seq=security-sage-v2&orientation=landscape"
              alt=""
              className="h-[0.9em] w-auto rounded-full"
            />
          </span>{" "}
          w pełni bezpieczne
          <span className="inline-flex items-center align-middle ml-2">
            <img
              src="https://readdy.ai/api/search-image?query=Miniature%20golden%20brass%20security%20padlock%20product%20photo%20on%20transparent%20background%2C%20small%20elegant%20lock%20icon%2C%20clean%20product%20shot%20with%20soft%20warm%20lighting%2C%20simple%20refined%20design%2C%20no%20text%20no%20logos%2C%20minimal%20aesthetic&width=80&height=60&seq=security-lock-v2&orientation=landscape"
              alt=""
              className="h-[0.9em] w-auto rounded-md"
            />
          </span>
        </h2>

        <div className="flex flex-col sm:flex-row items-start gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-6 py-3 bg-accent-700 text-background-50 rounded-full text-sm font-medium hover:bg-accent-800 transition-colors"
          >
            Sprawdź certyfikaty
            <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-6 py-3 border-2 border-foreground-200 text-foreground-700 rounded-full text-sm font-medium hover:border-foreground-400 transition-colors"
          >
            Czytaj więcej
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}